export default {"src":"/evde-internet/_next/static/media/Coins.1b3a5635.svg","height":24,"width":24};